import { render, staticRenderFns } from "./ManageQuotes.vue?vue&type=template&id=777e33ec&scoped=true"
import script from "./ManageQuotes.vue?vue&type=script&lang=js"
export * from "./ManageQuotes.vue?vue&type=script&lang=js"
import style0 from "./ManageQuotes.vue?vue&type=style&index=0&id=777e33ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777e33ec",
  null
  
)

export default component.exports